const plans = [
  { name: "标准版", price: "¥3,600", unit: "/月", desc: "适合中小企业数据分析起步", highlight: false, features: ["5个数据源接入", "标准分析模版20+", "月度报告自动生成", "销售趋势分析", "用户基础画像"] },
  { name: "旗舰版", price: "¥9,800", unit: "/月", desc: "适合多业态、多渠道零售企业", highlight: true, badge: "推荐选择", features: ["不限数据源接入", "自定义分析模型", "实时数据看板", "AI异常预警", "供应链优化模块", "财务预测引擎", "专属数据工程师"] },
  { name: "集团版", price: "联系报价", unit: "", desc: "适合多子公司、跨国集团企业", highlight: false, features: ["全部旗舰版功能", "多组织权限管理", "集团合并报表", "私有化部署", "与ERP/WMS集成", "驻场实施服务"] },
];

export default function BAPricing() {
  return (
    <section className="py-20 px-8 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-xs font-semibold text-emerald-600 tracking-widest uppercase mb-2 block">Pricing Plans</span>
          <h2 className="text-3xl font-bold text-slate-800 mb-3">灵活定价方案</h2>
          <p className="text-slate-500 text-sm">按需选择，均支持30天免费试用</p>
        </div>
        <div className="grid grid-cols-3 gap-6">
          {plans.map((p) => (
            <div key={p.name} className={`rounded-2xl p-7 border relative ${p.highlight ? "border-emerald-500 bg-gradient-to-b from-[#0a2a1a] to-[#0d4a2a] text-white" : "border-slate-200 bg-white"}`}>
              {p.badge && <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-emerald-400 text-[#0a2a1a] text-xs font-bold px-4 py-1 rounded-full whitespace-nowrap">{p.badge}</span>}
              <div className={`text-sm font-semibold mb-1 ${p.highlight ? "text-emerald-300" : "text-emerald-600"}`}>{p.name}</div>
              <div className="flex items-end gap-1 mb-2">
                <span className={`text-3xl font-bold ${p.highlight ? "text-white" : "text-slate-800"}`}>{p.price}</span>
                <span className={`text-sm mb-1 ${p.highlight ? "text-white/60" : "text-slate-400"}`}>{p.unit}</span>
              </div>
              <p className={`text-xs mb-6 ${p.highlight ? "text-white/60" : "text-slate-500"}`}>{p.desc}</p>
              <ul className="space-y-2.5 mb-8">
                {p.features.map((f) => (
                  <li key={f} className={`flex items-center gap-2 text-sm ${p.highlight ? "text-white/80" : "text-slate-600"}`}>
                    <i className={`ri-check-line flex-shrink-0 ${p.highlight ? "text-emerald-300" : "text-emerald-500"}`}></i>
                    {f}
                  </li>
                ))}
              </ul>
              <button className={`w-full py-2.5 rounded-lg text-sm font-semibold cursor-pointer whitespace-nowrap transition-all ${p.highlight ? "bg-emerald-400 hover:bg-emerald-300 text-[#0a2a1a]" : "border border-emerald-500 text-emerald-600 hover:bg-emerald-50"}`}>
                {p.price.includes("报价") ? "联系销售" : "免费试用"}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
